import { Modal, Button } from "antd";

interface IProps {
  visualizar: boolean;
  setVisualizar: any;
}
import Inversion from "../../../assets/comunas/inversionporarea.png"

export const ModalAvisoInfo: React.FC<IProps> = (props: IProps) => {

  const onCancel = () => {
    props.setVisualizar(false)
  }

  return (
    <Modal
      className="ant-modal-close-x2"
      maskStyle={{
        backgroundColor: "rgba(6, 100, 144 ,0.71)",
      }}
      visible={props.visualizar}
      onCancel={onCancel}
      width={800}
      footer={[
        <Button key="B_CERRAR_1" className="button-gray-ghost m-0" onClick={onCancel}>
          Cerrar
        </Button>,
      ]}
      cancelButtonProps={{ style: { display: "none" } }}
    >
      <div style={{fontSize: '1.2em', textAlign: 'center' }}>
        <span className="pb-3 font-size-20px font-family-Montserrat-SemiBold">
            ¡Ya casi empieza la Convocatoria Estímulos a los Talentos y Liderazgos de las Mujeres 2025!
        </span>
        <br />
				<br />
        <p style={{ textAlign: 'justify' }}>
            Por eso, este 9, 10 y 11 de abril abrimos el espacio para las observaciones de la ciudadanía, un momento clave para que leas los lineamientos y nos cuentes tu opinión.
        </p>
        <p style={{ textAlign: 'left' }}>
            Queremos leer tus ideas y tu mirada.
            Déjanos tus comentarios en: reconocimientomujeres@medellin.gov.co
        </p>
      </div>
    </Modal>
  );
};
